import {MyopBindMessage, MyopBindReplayMessage, Ref} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";
import {Serializable, SerializableSkeleton} from "../common/utils/serialization.ts";

const ReplayMessageKey = 'EventListenerCallbackMessage'

export class AddEventListenerMessage<T extends keyof HTMLElementEventMap = keyof HTMLElementEventMap> extends MyopBindMessage {

    replyMessageKey: MyopMessageKey = ReplayMessageKey;
    messageType = 'AddEventListenerMessage';
    cleanable = true;
    serializableSkeleton: SerializableSkeleton<HTMLElementEventMap[T]> = false // {} // empty

    constructor(public ref: Ref, public type: T, public handler: (message: EventListenerCallbackMessage) => void) {
        super(handler)
    }

    withSerializableSkeleton(serializableSkeleton: SerializableSkeleton<HTMLElementEventMap[T]>) {
        this.serializableSkeleton = serializableSkeleton;
        return this;
    }
}

export class EventListenerCallbackMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey;

    constructor(public replayToHandler: string, public e: Serializable<Event>) {
        super(replayToHandler);
        this.content = {
            e
        }
    }
}
